import { useMemo } from "react";
import { useLocation, useParams as useParamsRRD } from "react-router-dom";

export const useParams = <T extends string | Record<string, string | undefined>>() => {
  const { search } = useLocation();
  const routeParams = useParamsRRD();
  return useMemo(() => {
    const params = new URLSearchParams(search);
    const result: Record<string, string | undefined> = {
      ...routeParams,
    };

    params.forEach((value, key) => {
      if (result[key] === undefined) {
        result[key] = value;
      }
    });

    return result as Readonly<Partial<T>>;
  }, [routeParams, search]);
};
